const SET_IS_LOADING = "ADVISOR_INVITES/SET_IS_LOADING";
const SET_ERROR = "ADVISOR_INVITES/SET_ERROR";
const SET_PAGE = "ADVISOR_INVITES/SET_PAGE";
const RESET = "ADVISOR_INVITES/RESET";

const Types = {
  SET_IS_LOADING,
  SET_ERROR,
  SET_PAGE,
  RESET,
};

export default Types;
